module.exports = __webpack_public_path__ + "static/media/miro-logo.b5c715f9.svg";